import { getP44Env } from '@project44/ui-utils';

import { newPasswordValidationType } from '../utils/types';

const { MOVEMENT_BASE_URL, PUBLIC_API_BASE_URL, VOC_BASE_URL, ENV } =
  getP44Env();

export const MOVEMENT_LOGIN_PAGE = `${MOVEMENT_BASE_URL}/login`;
export const PORTAL_V2_PUBLIC_API_BASE_URL = `${PUBLIC_API_BASE_URL}/api/portal/v2`;
export const PORTAL_V2_DASHBOARD = `${VOC_BASE_URL}/portal/v2/dashboard`;
export const ENVIRONMENT = ENV;
export const VOC_ORIGIN = VOC_BASE_URL;

export const enum LoginPageResolverEnum {
  LOGIN_SSO = 'LOGIN_SSO',
  LOGIN_NON_SSO = 'LOGIN_NON_SSO',
}

export const newPasswordValidatonState: newPasswordValidationType = {
  length: 'unknown',
  lowerCase: 'unknown',
  upperCase: 'unknown',
  number: 'unknown',
};

export const enum PagesEnum {
  FORGOT_PASSWORD = '/login/forgot-password',
  SET_PASSWORD = '/login/create-new-password',
}

export const WHITELISTED_REDIRECT_URL_REGEX = {
  'qa-integration': [
    'http(s?):\\/\\/movement\\.qa-integration\\.p-44\\.com(\\/.+)?(%.+)?$',
    'http(s?):\\/\\/(.+\\.)*voc\\.qa-integration\\.p-44\\.com(\\/.+)?(%.+)?$',
    'http(s?):\\/\\/(.+\\.)*api\\.qa-integration\\.p-44\\.com(\\/.+)?(%.+)?$',
    'https:\\/\\/(.+\\.)*voc\\.project44\\.com(\\/.+)?(%.+)?$',
    'https:\\/\\/(.+\\.)*api\\.project44\\.com(\\/.+)?(%.+)?$',
  ],
  'qa-stage': [
    'http(s?):\\/\\/movement\\.qa-stage\\.p-44\\.com(\\/.+)?(%.+)?$',
    'http(s?):\\/\\/(.+\\.)*voc\\.qa-stage\\.p-44\\.com(\\/.+)?(%.+)?$',
    'http(s?):\\/\\/(.+\\.)*api\\.qa-stage\\.p-44\\.com(\\/.+)?(%.+)?$',
  ],
  'production-na': [
    'https:\\/\\/movement\\.project44\\.com(\\/.+)?(%.+)?$',
    'https:\\/\\/(.+\\.)*voc\\.project44\\.com(\\/.+)?(%.+)?$',
    'https:\\/\\/(.+\\.)*api\\.project44\\.com(\\/.+)?(%.+)?$',
  ],
  'production-eu': [
    'https:\\/\\/movement\\.eu\\.project44\\.com(\\/.+)?(%.+)?$',
    'https:\\/\\/(.+\\.)*voc\\.project44\\.com(\\/.+)?(%.+)?$',
    'https:\\/\\/(.+\\.)*api\\.project44\\.com(\\/.+)?(%.+)?$',
  ],
  sandbox: [
    'https:\\/\\/movement\\.sandbox\\.p-44\\.com(\\/.+)?(%.+)?$',
    'https:\\/\\/(.+\\.)*voc\\.sandbox\\.p-44\\.com(\\/.+)?(%.+)?$',
    'https:\\/\\/(.+\\.)*api\\.sandbox\\.p-44\\.com(\\/.+)?(%.+)?$',
  ],
};
